import httpService from '@/modules/common/services/httpService';

const gatewayService = httpService.create(window.pov_config.VUE_APP_API_URL_GATEWAY);
const baseRoute = 'v3/communication';

const getAvailablePhoneNumbers = async (countryCode = 'US') => gatewayService
  .get(`${baseRoute}/available_phone_numbers`, {
    country_code: countryCode,
    features: JSON.stringify(['SMS']),
  })
  .then((res) => res.data);

const claimPhoneNumber = async (phoneNumber, countryCode = 'US', verificationRequestData = null) => {
  const payload = {
    country_code: countryCode,
    phone_number: phoneNumber,
    features: ['SMS'],
  };

  if (verificationRequestData) {
    payload.verification_request_data = verificationRequestData;
  }

  return gatewayService
    .post(`${baseRoute}/business_phone_numbers`, payload)
    .then((res) => res.data);
};

const getActiveTextingPhoneNumber = async (params = {}) => {
  const res = await gatewayService.get(`${baseRoute}/business_phone_numbers`, params);
  const numbers = res.data?.data?.business_phone_numbers || [];
  return numbers.find((number) => number.status?.toLowerCase() === 'active'
    && number.features?.includes('SMS'));
};

const updateBusinessPhoneNumber = async (uid, data) => {
  const res = await gatewayService.put(`${baseRoute}/business_phone_numbers/${uid}`, data);
  return res.data?.data;
};

export default {
  getAvailablePhoneNumbers,
  claimPhoneNumber,
  getActiveTextingPhoneNumber,
  updateBusinessPhoneNumber,
};
